/**
 * @desc 更新
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.WarehouseSkuRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/warehouseSku/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
